import ImageContent from "../../../../../lib/html5-software-library/src/ranj/eng/content/ImageContent";
import MeetingNotesContent from "../../../../../lib/html5-software-library/src/ranj/eng/content/MeetingNotesContent";
import NPCContent from "../../../../../lib/html5-software-library/src/ranj/eng/content/NPCContent";
import TextContent from "../../../../../lib/html5-software-library/src/ranj/eng/content/TextContent";
import { DialogOption } from "../../../../../lib/html5-software-library/src/ranj/eng/dialog/engine/model/Dialog";
import RevisableLanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import LayoutManager from "../../../../../lib/html5-software-library/src/ranj/layout/LayoutManager";
import AssetLibrary from "../../../core/assetloading/AssetLibrary";
import ClickEaterFactory from "../../../core/ui/ClickEaterFactory";
import { AbstractDialogPlayerMediator } from "../../../ngt/dialog/view/AbstractDialogPlayerMediators";
import NPCModel from "../../../ngt/scenario/NPCModel";

export default class ConversationStatementScreenMediator extends AbstractDialogPlayerMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LayoutManager} layoutManager 
     * @param {ClickEaterFactory} clickEaterFactory 
     * @param {AssetLibrary} assetLibrary 
     * @param {RevisableLanguagePack} languagePack 
     * @param {NPCModel} npcModel 
     * @param {SoundManager} soundManager
     * @param {SoundConfig} soundConfig
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory, assetLibrary, languagePack, npcModel, soundManager,soundConfig) {
        super(target, dispatcher, layoutManager, clickEaterFactory);

        this._assetLibrary = assetLibrary;
        this._languagePack = languagePack;
        this._npcModel = npcModel;
        this._soundManager = soundManager;
        this._soundConfig = soundConfig;
    }

    initialize() {
        super.initialize();

        this._characterNameTextField = this._target.characterNameTextField;
        this._characterNameTextField.text = "";

        this._characterFunctionTextField = this._target.characterFunctionSubTextField;
        this._characterFunctionTextField.text = "";

        this._statementTextField = this._target.statementTextField;
        this._statementTextField.text = "";

        this._continueButton = this.createButton(this._target.continueButton, this._handleContinueButton.bind(this), this._languagePack.getText('conversationStatement.continueButtonLabel'));
        this._continueButton.setVisible(false);

        this._imageContainer = this._target.imageContainer;

        const dialogPlayer = this.getCustomData().dialogPlayer;
        this.setDialogPlayer(dialogPlayer);

        /** @type {MeetingNotesContent} */
        const conversationStatementContent = this.getDialogPlayer().getContent();
        const npcId = conversationStatementContent.getNotesTitle();
        /** @type {NPCContent} */
        const npcContent = this._npcModel.getNpcByNpcID(npcId);
        if (npcContent) {
            this._characterNameTextField.text = npcContent.getName();
            this._characterFunctionTextField.text = npcContent.getRole();
        }

        // this.stretchBackground();
        this.preventClickThrough();
    }

    destroy() {
        super.destroy();

        this._imageContainer.removeAllChildren();
    }

    _handleCommandSequenceEnd(evt) {
        const currentOptions = this.getDialogPlayer().getCurrentOptions();
        if (currentOptions.length === 0) {
            console.warn(`Conversation statement dialogs need exactly one option that will be completed when the continue button is clicked by the player. There are no options.`);
            return;
        }
        if (currentOptions.length > 1) {
            console.warn(`Conversation statement dialogs need exactly one option that will be completed when the continue button is clicked by the player. There are too many options.`);
            return;
        }

        /** @type {DialogOption} */
        const option = currentOptions[0];
        /** @type {TextContent} */
        const optionContent = option.getData().getData().content;
        const optionText = optionContent.getText();
        if (optionText) {
            this._continueButton.setLabel(optionText);
        }

        this._continueButton.setVisible(true);
    }

    _onDialogContent(evt) {
        super._onDialogContent(evt);

        const npcContent = this._npcModel.getNpcByNpcID(this._currentCharacterID);
        if (npcContent) {
            this._characterNameTextField.text = npcContent.getName();
            this._characterFunctionTextField.text = npcContent.getRole();
        }
    }

    /**
     * @param {TextContent} content 
     */
    _handleTextContent(content) {
        this._statementTextField.text = content.getText();
    }

    /**
     * @param {ImageContent} content 
     */
    _handleImageContent(content) {
        this._imageContainer.removeAllChildren();

        // Retrieve image
        const imageId = content.getImage();
        
        const image = this._assetLibrary.getAsset(imageId);
        if (!image) {
            console.warn(`Conversation statement image not found!`, imageId);
            return;
        }

        const bitmap = new createjs.Bitmap(image);

        // Center image
        const bitmapBounds = bitmap.getBounds();
        bitmap.regX = bitmapBounds.width * .5;
        bitmap.regY = bitmapBounds.height * .5;

        this._imageContainer.addChild(bitmap);

        this._playBackgroundAudio(imageId);
    }

    _playBackgroundAudio(imageId) {
        if(this._backgroundAudio!= null) {
            this._soundManager.stopSound(this._backgroundAudio);
            console.log("Stopped audio: " + this._backgroundAudioId);
            if(this._soundManager.isSoundPlaying(this._backgroundAudioId)) {
                let soundInstance = this._soundManager.getSoundInstance(this._backgroundAudioId);
                this._soundManager.stopSound(soundInstance);
            }
        }
        
        this._backgroundAudioId = this._soundConfig.getSoundId(imageId);
        if(!this._soundManager.isSoundPlaying(this._backgroundAudioId)) {
            this._backgroundAudio = this._soundManager.playSound(this._backgroundAudioId, null,null,0,0,-1, this._soundConfig.getVolume(this._backgroundAudioId));
        }
    }

    _onDialogEnd(evt) {
        this._soundManager.stopSound(this._backgroundAudio);
        console.log("Stopped audio: " + this._backgroundAudioId);

        if(this._soundManager.isSoundPlaying(this._backgroundAudioId)) {
            let soundInstance = this._soundManager.getSoundInstance(this._backgroundAudioId);
            this._soundManager.stopSound(soundInstance);
        }

        super._onDialogEnd(evt);
    }

    _handleContinueButton() {
        const options = this.getDialogPlayer().getCurrentOptions();
        this.getDialogPlayer().optionChosen(options[0]);
    }
}